export default __webpack_public_path__ + "static/media/Countdown_0.f8517322.png";